import { EmptyGraphic } from 'app/components/empty-graphic';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { Loan, LoanType } from 'app/types/loan';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator } from 'react-native';
import { ResponsiveLoanPlanner } from './responsive-loan-planner';

export function DesktopLoans({
  isLoading,
  loanType,
  loans,
  tPrefix,
}: {
  isLoading: boolean;
  loanType: LoanType;
  loans: Loan[];
  tPrefix: string;
}) {
  const { t } = useTranslation('loans');

  return (
    <Column
      flex={1}
      minHeight={0}
      gap="spacing.general.x6"
      paddingHorizontal="spacing.general.x8"
      paddingVertical="spacing.general.x8"
    >
      <Text fontWeight="600" variant="headerSmall">
        {t(`${tPrefix}${loanType}.title`)}
      </Text>
      {isLoading && loans.length === 0 ? (
        <ActivityIndicator accessibilityLabel={t('calendar.loading')} size="large" />
      ) : loans.length === 0 ? (
        <EmptyGraphic
          invertTexts
          primary={t(`${tPrefix}${loanType}.empty.secondLine`)}
          secondary={t(`${tPrefix}${loanType}.empty.firstLine`)}
        />
      ) : (
        <ResponsiveLoanPlanner loans={loans} loanType={loanType} />
      )}
    </Column>
  );
}
